<template>
  <BaseDialog
    :actionAllow="false"
    width="50vw"
    v-model="showTagAssignmentDialog"
    title="Assign Tags "
  >
    <template #information>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on" v-bind="attrs">
            <v-text-field
              outlined
              background-color="background_color"
              :label="
                tab == 0
                  ? `select ${fleetModule.vehicle}`
                  : `select ${customerAddressModule.customerAddress}`
              "
              hide-details="auto"
              dense
              readonly
              clearable
              class="py-4"
              @blur="resetList"
            >
            </v-text-field>
          </span>
        </template>
        <v-list>
          <v-container
            id="container"
            style="max-height: 400px; position: relative; top: 0"
            class="overflow-y-auto pa-0"
          >
            <v-text-field
              style="
                position: sticky;
                top: 0;
                left: 0;
                right: 0;
                background-color: white !important;
                z-index: 1;
              "
              outlined
              class="pa-4 px-5"
              label="search"
              background-color="background_color"
              hide-details="auto"
              @click.stop.prevent=""
              dense
              v-model="searchInput"
              clearable
            >
            </v-text-field>

            <v-list
              class="pa-0 ma-0"
              no-gutters
              v-scroll:#container="onScroll"
              align="center"
              justify="center"
            >
              <v-list-item
                style="border: 1px solid #80808021"
                v-for="(item, index) in elementList"
                :key="index"
              >
                <v-list-item-title class="d-flex justify-space-between">
                  <span> {{ item[keyToDisplay] }}</span>
                  <span>
                    <PrimaryButton
                      v-if="permissions.add"
                      :disabled="selectedIDs().indexOf(item.id) > -1"
                      @click.stop.prevent="assignTag(item.id)"
                      name="Add"
                    >
                    </PrimaryButton>
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-container>
        </v-list>
      </v-menu>
      <v-tabs v-model="tab" color="deep-purple accent-4" left>
        <v-tab> {{ fleetModule.vehicle }} </v-tab>
        <v-tab> {{ customerAddressModule.customerAddress }} </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <div class="py-5">
          <div
            v-if="assignedAssetsList && assignedAssetsList.length > 0"
            style="min-height: 20vh; max-height: 50vh"
            class="overflow-y-auto"
          >
            <v-card
              outlined
              elevation="0"
              v-for="(tag, i) in assignedAssetsList"
              :key="i"
              class="px-6 py-4"
            >
              <v-row no-gutters>
                <v-col cols="2">
                  <v-icon color="primary">{{
                    tab == 0 ? "mdi-truck" : "mdi-map-marker-outline"
                  }}</v-icon>
                </v-col>
                <v-col cols="9">
                  {{ tag[keyToDisplay] }}
                </v-col>
                <v-col cols="1">
                  <v-icon
                    color="red"
                    @click="removeTag(tag.id)"
                    v-if="permissions.delete"
                  >
                    mdi-close
                  </v-icon>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div v-else class="d-flex justify-center align-center pt-8 pb-6">
            <span>No Tag Assign...</span>
          </div>
        </div>
      </v-tabs-items>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { bus } from "@/main";
import { fleetModule, customerAddressModule } from "@/utils/moduleMapping";
export default {
  components: { BaseDialog },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tagId: {
      type: Number,
    },
  },
  computed: {
    showTagAssignmentDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // selectedIDs() {
    //   return this.assignedAssetsList.map((item) => item.id);
    // },
    assignedAssetsList() {
      if (this.tab == 0) {
        return this.assignedVehicleList;
      } else {
        return this.assignedCustomerAddressList;
      }
    },
  },
  data() {
    return {
      customerAddressModule,
      fleetModule,
      keyToDisplay: "vehicle_number",
      tab: 0,
      assignTagList: [],
      searchInput: null,
      elementList: [],
      totalCount: 0,

      assignedVehicleList: [],
      assignedCustomerAddressList: [],

      isScrollable: true,
      permissions: null,

      searchTimeout: null,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.permissions = this.$permissions.getPermission("trip_planning");
        this.getList({}, true);
        this.getAssignedAssetsList(this.tagId);
      }
    },
    tab(val) {
      this.getList({}, true);
      if (val == 0) {
        this.keyToDisplay = "vehicle_number";
      } else {
        this.keyToDisplay = "location_id";
      }
    },
    searchInput() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getList({}, true);
      }, 400);
    },
  },
  methods: {
    selectedIDs() {
      return this.assignedAssetsList.map(
        (item) => item[this.tab == 0 ? "vehicle_id" : "customer_address_id"]
      );
    },
    resetList() {
      this.assignTagList = [];
      if (this.searchInput && this.searchInput.length != 0) {
        this.searchInput = null;
        this.getList({}, true);
      } else {
        this.searchInput = null;
      }
    },
    getList(params, reload) {
      if (this.tab == 0) {
        this.getVehicleList(params, reload);
      } else {
        this.getCustomerAddressList(params, reload);
      }
    },
    assignTag(id) {
      let payload;
      let module;
      let method;
      if (this.tab == 0) {
        payload = {
          vehicle: id,
          tag: this.tagId,
        };
        module = "vehicleTags";
        method = "createVehicleTagsObject";
      } else {
        payload = {
          customer_address: id,
          tag: this.tagId,
        };
        module = "customerAddressTags";
        method = "createCustomerAddressTagsObject";
      }
      bus.$emit("showLoader", true);
      this.$api[module][method](payload)
        .then(() => {
          bus.$emit("showToastMessage", {
            message: "Tag assigned successfully!",
            color: "success",
          });
          this.getAssignedAssetsList(this.tagId);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showToastMessage", {
            message: "Couldn't assign tag!",
            color: "error",
          });
        });
    },
    removeTag(id) {
      let module;
      let method;
      if (this.tab == 0) {
        module = "vehicleTags";
        method = "deleteVehicleTagsObject";
      } else {
        module = "customerAddressTags";
        method = "deleteCustomerAddressTagsObject";
      }
      this.$api[module][method](id)
        .then(() => {
          bus.$emit("showToastMessage", {
            message: "Tag removed successfully!",
            color: "success",
          });
          this.getAssignedAssetsList(this.tagId);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showToastMessage", {
            message: "Couldn't remove tag!",
            color: "error",
          });
        });
    },
    getAssignedAssetsList(id) {
      bus.$emit("showLoader", true);
      this.$api.tag
        .getAssignedAssetsList(id)
        .then((res) => {
          this.assignedVehicleList = res.data.vehicle;
          this.assignedCustomerAddressList = res.data.customer_addresses;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    onScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isScrollable) {
        this.isScrollable = false;
        this.getList({}, false);
      }
    },
    getCustomerAddressList(params = {}, reload = false) {
      params = {
        ...params,
        limit: 10,
        offset: reload ? 0 : this.elementList.length,
      };

      if (this.searchInput) {
        params.search = this.searchInput;
      }

      bus.$emit("showLoader", true);
      this.$api.customerAddress
        .getCustomerAddressList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          if (reload) {
            this.elementList = res.data;
          } else {
            this.elementList = [...this.elementList, ...res.data];
          }
          this.totalCount = res.count;
          if (this.totalCount != this.elementList.length) {
            this.isScrollable = true;
          }
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
        });
    },
    getVehicleList(params = {}, reload = false) {
      params = {
        ...params,
        limit: 10,
        offset: reload ? 0 : this.elementList.length,
      };
      if (this.searchInput) {
        params.search = this.searchInput;
      }
      bus.$emit("showLoader", true);
      this.$api.vehicle
        .getVehicleList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          if (reload) {
            this.elementList = res.data;
          } else {
            this.elementList = [...this.elementList, ...res.data];
          }
          this.totalCount = res.count;
          if (this.totalCount != this.elementList.length) {
            this.isScrollable = true;
          }
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
